const zh = {
    addMember: '添加成员',
    avatar: '头像',
    phNumber: '手机号',
    permissions: '权限',
    isAdmin: '是否为系统管理员',
    acntExists: '账号已存在',
    addSuccess: '添加成功',
    addFailed: '添加失败',
    tips: '提示',
    confirmAction: '您确定要',
    disable: '禁用',
    enable: '启用',
    bascInfoUp: '基本信息修改成功',
    userPerSetSuc: '用户权限设置成功',
    pwdChanged: '密码修改成功',
    mobileChangeSuc: '手机号修改成功',
    aginLogin: '请重新登录!',
    validaFailed: '校验失败',
    pwd: '密码',
    enterPwd: '请输入密码',
    pwdMinLength: '密码至少6位',
    plConfirmPwd: '请确认密码',
    confirmPwd: '确认密码',
    pwdDiff: '两次密码不一致',
    reenterPwd: '请再次确认密码',
    memberDetails: '成员详情',
    basicInfo: '基本信息',
    searchPrompt: '请输入name1、name2、手机号进行搜索',
    sure: '确定',
    viewDetails: '查看详情',
    thisMember: '该成员吗',
    maxLengthTip: '内容超出最大长度限制！',
    changeStatusSucc: '操作成功!',
    phNumberTip: '请输入手机号',
    updateFail: '修改失败',
    userDataNoExistTip: '用户数据不存在或用户被禁用',
    mobileEmpty: '手机号不能为空',
    userFetchFail: '获取用户信息失败',
    name1: '姓名1',
    name2: '姓名2',
};

export default zh;